export const environment = {
    apiBaseUrl: 'https://claro.qbit.lv',
    production: false,
    luidaisUrl: 'https://luidais-metrum.qbit.lv',
};
